import _ from 'lodash';
import { GAIN_VALUES, HP_VALUES, LP_VALUES } from '@/shared/config';

/**
 * Produces the all-unchecked section selection for the PDF report settings. Returns one false flag per report section, from table of contents through ECG disclosure.
 *
 * @returns An object with every report section flag set to false.
 */
const generateInitalCheckboxState = () => ({
  tableOfContent: false,
  summary: false,
  dailySummary: false,
  hrChart: false,
  afibAnalysis: false,
  veAnalysis: false,
  sveAnalysis: false,
  stTrend: false,
  hrvSummary: false,
  hrvRrInterval: false,
  qtcCharts: false,
  ecgDisclosure: false,
});

/**
 * Builds the gain and filter dropdown options for the PDF report settings. Maps gain values to mm/mV labels, high-pass values to Hz with zero shown as No, and low-pass values likewise, labelling 50 and 60 Hz as Notch.
 *
 * @returns An object carrying gainOptions, hpFilterOptions and lpFilterOptions.
 */
const generateOptions = () => {
  const gainOptions = _.map(GAIN_VALUES, (item) => ({
    label: `${item} mm/mV`,
    value: item,
  }));
  const hpFilterOptions = _.map(HP_VALUES, (item) => ({
    label: item !== 0 ? `${item} Hz` : 'No',
    value: item,
  }));
  const lpFilterOptions = _.map(LP_VALUES, (item) => ({
    label: item !== 0 ? (item !== 50 && item !== 60 ? `${item} Hz` : `${item} Hz (Notch)`) : 'No',
    value: item,
  }));
  return {
    gainOptions,
    hpFilterOptions,
    lpFilterOptions,
  };
};

export { generateInitalCheckboxState, generateOptions };
